<template>
  <div id="rightBtm">
    <div class="bg-color-black">
      <myTitle :icon="'chart-line'">生活指数</myTitle>
      <div class=" life-box">
        <div class="item d-flex jc-around ai-center" v-for="item in list" :key="item.text1">
          <div class="center d-flex jc-around ai-center">
            <img  :src="item.img" />
          </div>
          <div class="desc">
            <div class="text">{{item.text1}}</div>
            <div class="text">{{item.text2}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
import myTitle from '@/components/common/title'
export default {
  data() {
    return {
      list: [
        {
          img: require('../../../assets/life1.png'),
          text1: '穿衣指数',
          text2: '寒冷'
        },
        {
          img: require('../../../assets/life2.png'),
          text1: '化妆指数',
          text2: '保湿'
        },
        {
          img: require('../../../assets/life3.png'),
          text1: '紫外线指数',
          text2: '最弱'
        },
        {
          img: require('../../../assets/life4.png'),
          text1: '开窗通风',
          text2: '适宜开窗'
        },
        {
          img: require('../../../assets/life5.png'),
          text1: '感冒指数',
          text2: '易发'
        },
        {
          img: require('../../../assets/life6.png'),
          text1: '户外运动',
          text2: '适宜'
        }
      ]
    }
  },
  components: {
    myTitle
  },
}
</script>
    
<style lang="scss" scoped>
$box-height: 450px;
$box-width: 100%;

#rightBtm {
  padding: 20px 16px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;

  .bg-color-black {
    height: $box-height - 35px;
    border-radius: 10px;
  }

  .item {
    height: 120px;
    text-align: center;
    border: 1px solid #4b5578;
  }

  .title {
    line-height: 40px;
    text-align: center;
    margin-left: -30px;
    padding-top: 5px;
  }

  .text {
    color: #c3cbde;
    // padding-left: 30px;
    text-align: center;
    font-size: 26px;
    line-height: 30px;
  }

  .center {
    height: 90px;
    width: 90px;
    border-radius: 50%;
    background: rgb(67 148 228 / 32%);
  }

  img {
    // height: 100%;
    height: 50px;
  }

  .life-box {
    display: grid;
    grid-template-columns: repeat(2, 50%);
    padding-top: 10px;
    grid-gap: 5px;
    padding: 5px;
    padding-right: 10px;
  }
}
</style>
    